'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoErlenmeyerFlask = function IoErlenmeyerFlask(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm34.3 30.9c0.5 0.7 0.7 1.6 0.7 2.5 0 2.2-1.2 4.1-4.9 4.1h-20.2c-3.6 0-4.9-1.9-4.9-4.1 0-0.9 0.2-1.8 0.7-2.5l3.8-5.7 3.9-6c1-1.5 1.6-3.4 1.6-5.4v-7.2s-1.1-2.7-1.2-3.4c-0.2-0.6 0-0.7 1.3-0.7h9.8c1.3 0 1.4 0.1 1.3 0.7-0.2 0.7-1.2 1.7-1.2 3.3v7.3c0 2 0.5 3.9 1.5 5.4z m-2.3 3.6c0.2-0.3 0.5-0.7 0.5-1.1 0-0.4-0.2-0.8-0.3-1.1l-7.9-11.8c-1.3-2-1.8-4.3-1.8-6.8v-8.7h-5v8.8c0 2.5-0.7 4.8-2 6.7l-7.7 11.8c-0.1 0.3-0.3 0.7-0.3 1.1 0 0.4 0.2 0.8 0.5 1.1 0.3 0.3 0.9 0.5 1.9 0.5h20.2c1 0 1.5-0.2 1.9-0.5z m-1.6-2.4c0.1 0.2 0.2 0.5 0.2 0.6 0 0.6-0.4 1.2-1.1 1.2h-19c-0.6 0-1.1-0.5-1.1-1.1 0-0.2 0.1-0.5 0.2-0.6l6.3-9.7h8.1l6.4 9.7v-0.1z m-6.8-5.4c0.2 0.1 0.3 0.2 0.5 0.2s0.2 0 0.4-0.2c0-0.1 0.2-0.3 0.2-0.5s-0.1-0.3-0.2-0.4c-0.1-0.2-0.3-0.2-0.4-0.2s-0.3 0-0.5 0.2c-0.1 0.1-0.2 0.3-0.2 0.5s0 0.3 0.2 0.4z m3.7 4.6c0.3-0.1 0.3-0.5 0.1-0.8l-1.8-2.8c-0.1-0.2-0.3-0.4-0.5-0.4-0.2 0-0.3 0-0.3 0.1-0.3 0.2-0.3 0.6-0.2 0.9l1.8 2.8c0.1 0.1 0.4 0.3 0.6 0.3 0 0 0.2 0 0.3-0.1z' })
        )
    );
};

exports.default = IoErlenmeyerFlask;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/erlenmeyer-flask.js
// module id = 2501
// module chunks = 168707334958949